<div>
  <h4>Events</h4>

  <ul (click)="handleClick('')">
    <li class="event-item">All Events</li>
    <hr />
  </ul>

  <ul *ngFor="let event of allEvents" (click)="handleClick(event.partitionKey)">
    <li class="event-item">
      {{ event.partitionKey }}
    </li>
    <hr />
  </ul>
</div>
